import { getQueryParams } from '../routing/getQueryParams';
import { Data } from '../signup-data/DATA';
import { isPartnerSignup } from '../store/flow/selectors';
import { getQueryParamKeyFromDataKey } from './getQueryParamKeyFromDataKey';
import { isPostVerification } from './settingsSelectors';
const NON_PREFILLABLE = [Data.Industry, Data.JobRole, Data.Password, Data.CodeVerification, Data.CrmExperienceLevel];
const SKIP_PREFILLED_PARAM = 'skip_prefilled';
export const shouldSkipPrefilledSteps = () => {
  return SKIP_PREFILLED_PARAM in getQueryParams();
};
export const getPrefilledDataKeys = () => {
  const queryParams = getQueryParams();
  return Object.values(Data).filter(dataKey => queryParams[getQueryParamKeyFromDataKey(dataKey)]);
};
export const getPrefilledSignupData = data => {
  return Object.values(Data).filter(dataPoint => !NON_PREFILLABLE.includes(dataPoint)).reduce((prefills, dataKey) => {
    const valueToPrefill = data[getQueryParamKeyFromDataKey(dataKey)];

    if (valueToPrefill !== null && valueToPrefill !== undefined) {
      prefills[dataKey] = data[getQueryParamKeyFromDataKey(dataKey)];
    }

    return prefills;
  }, {});
};
export const getPrefilledDataQueryParams = () => {
  const queryParams = getQueryParams();
  return Object.values(Data).filter(key => {
    if (isPostVerification() && (key === Data.Email || key === Data.Token)) {
      return true;
    }

    if (isPartnerSignup()) {
      return key === Data.Country;
    }

    return false;
  }).reduce((prefills, dataKey) => {
    const valueToPrefill = queryParams[getQueryParamKeyFromDataKey(dataKey)];

    if (valueToPrefill !== null && valueToPrefill !== undefined) {
      prefills[dataKey] = queryParams[getQueryParamKeyFromDataKey(dataKey)];
    }

    return prefills;
  }, {});
};